import React, {useEffect, useState} from 'react';
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import PeriodsDropdown from "../Components/Dropdowns/PeriodsDropdown";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import UnorderedListItems from "../../utils/UnorderedListItems";
import moment from "moment";
import {PeriodReleaseWeek} from "./PeriodReleaseWeek";


export const PeriodReleaseChecklist = () => {

    const [selectedPeriod, setSelectedPeriod] = useState(undefined)
    const [weeksInPeriod, setWeeksInPeriod] = useState([])

    useEffect(() => {
        makeApolloClientCall('{ getNextPeriodIfExists {periodAbbreviation} }')
            .then(data => {
                const currentPeriod = data.getNextPeriodIfExists.periodAbbreviation;
                setSelectedPeriod(currentPeriod)
                getPeriodWeeks(currentPeriod)
            })
    }, []);


    const updatePeriodCallback = (value) => {
        setSelectedPeriod(value)
        getPeriodWeeks(value)
    }

    const getPeriodWeeks = (periodAbbreviation) => {
        makeApolloClientCall(`{ periodDetails(periodAbbreviation: "${periodAbbreviation}") {weeks{endDate}} }`)
            .then(data => {
                const weeks = data.periodDetails[0].weeks.map(week => week.endDate);
                const periodEndWeek = weeks[0]
                const weeksComponents = weeks.map(endDate => <PeriodReleaseWeek week={endDate}/>)
                const prepWeek = <PeriodReleaseWeek title={'Prep Week: '}
                                                    week={getImportantDates(periodEndWeek, 7)}/>;
                const releaseWeek = <PeriodReleaseWeek title={'Release Week: '}
                                                       week={getImportantDates(periodEndWeek, 14)}/>;
                weeksComponents.unshift(prepWeek)
                weeksComponents.unshift(releaseWeek)
                setWeeksInPeriod(weeksComponents)
            })
    }

    const getImportantDates = (endDate, offset) => moment(endDate).add(offset, 'days').format('YYYY-MM-DD');

    return <Page name={'Period Release Checklist'}
                 breadCrumbs={<Breadcrumbs items={[{label: "Market Insights"}, {label: "Checklist"}]}/>}>
        <PeriodsDropdown id={"periods"} updatePeriod={updatePeriodCallback} selectedPeriod={selectedPeriod}/>
        <UnorderedListItems listItems={weeksInPeriod} title={'Weeks In Period:'}/>
    </Page>
}

export default PeriodReleaseChecklist;